module.exports = __webpack_public_path__ + "img/field-project-8.c968bbd5.svg";